const class_1_Config = {
    mode: ' :-  Offline',
    Batch_no: ' :-  10-12 in 1 batch',
    description:
      ':-  Reading fluency, basic math skills, social interaction, handwriting, and scientific curiosity.',
    };
const class_2_Config = {
    mode: ' :-  Offline',
    Batch_no: ' :-  10-12 in 1 batch',
    description:
      ':-  Improve reading fluency,  basic math skills, comprehension.',
    };
const class_3_Config = {
    mode: ' :-  Offline',
    Batch_no: ' :-  10-12 in 1 batch',
    description:
      ':-  Reading fluently, mastering basic math operations, developing  thinking skills.',
    };
const class_4_Config = {
    mode: ' :-  Offline',
    Batch_no: ' :-  10-12 in 1 batch',
    description:
      ':-  Master multiplication, division, fractions, develop reading comprehension, write structured paragraphs.',
    };
const class_5_Config = {
    mode: ' :-  Offline',
    Batch_no: ' :-  10-12 in 1 batch',
    description:
      ':-  Master basic operations, fractions, decimals, basic geometry, and interpret data.',
    };
const class_6_Config = {
    mode: ' :-  Offline',
    Batch_no: ' :-  10 in 1 batch',
    description:
      ':-  Understand fractions, decimals, basic geometry, critical reading, writing, and scientific concepts.',
    };
const class_7_Config = {
    mode: ' :-  Offline',
    Batch_no: ' :-  10 in 1 batch',
    description:
      ':-  Master basic algebra, enhance reading comprehension, write structured essays, understand scientific method.',
    };
const class_8_Config = {
    mode: ' :-  Offline',
    Batch_no: ' :-  10 in 1 batch',
    description:
      ':-  Master basic algebra, improve reading comprehension, enhance writing skills, explore scientific concepts, understand historical events.',
    };
const class_9_Config = {
    mode: ' :-  Offline',
    Batch_no: ' :-  10 in 1 batch',
    description:
      ':-  Master algebra, improve writing skills, comprehend complex texts, grasp scientific concepts.',
    };
const class_10_Config = {
    mode: ' :-  Offline',
    Batch_no: ' :-  10 in 1 batch',
    description:
      ':-  Master Algebra, Geometry, Chemistry basics, understand World History.',
    };
const class_11_Config = {
    mode: ' :-  Offline',
    Batch_no: ' :-  5-10 in 1 batch',
    description:
      ':-  Master algebra, basic calculus, scientific reasoning, research skills, explore career options, engage in extracurriculars, understand civics.',
    };
const class_12_Config = {
    mode: ' :-  Offline',
    Batch_no: ' :-  5-10 in 1 batch',
    description:
      ':-  Master advanced academic content, refine research skills, improve communication, demonstrate civic and global awareness, prepare for higher education or career, and exhibit personal and social responsibility.',
    };

  
   
  export {

    class_1_Config,
    class_2_Config,
    class_3_Config,
    class_4_Config,
    class_5_Config,
    class_6_Config,
    class_7_Config,
    class_8_Config,
    class_9_Config,
    class_10_Config,
    class_11_Config,
    class_12_Config,
  
         };